"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function CheckCircle42Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 42, height: 42, viewBox: "0 0 42 42", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 21C5 12.1634 12.1634 5 21 5C24.7175 5 28.1373 6.26678 30.8538 8.39339L32.1571 6.87398C29.0903 4.44871 25.2133 3 21 3C11.0589 3 3 11.0589 3 21C3 30.9411 11.0589 39 21 39C30.9411 39 39 30.9411 39 21C39 19.4472 38.8031 17.9391 38.4327 16.5L36.7574 18C36.9168 18.9063 37 19.8393 37 20.7923C37 29.6288 29.8366 37 21 37C12.1634 37 5 29.8366 5 21ZM17.7236 30.6005L38.9104 9.38015L37.4629 8L17.6497 27.7797L9.37325 19.9631L8 21.4171L17.7236 30.6005Z", fill: "#383F49" }));
}
function CheckCircle42(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(CheckCircle42Svg, Object.assign({}, svgProps)));
}
exports.default = CheckCircle42;
//# sourceMappingURL=CheckCircle42.js.map